import * as React from 'react';
import locales from '../constants/locales';
import {forEach} from 'lodash';
import {IntlProvider, addLocaleData} from 'react-intl';
import {useEffect, useState} from "react";
const DEFAULT_LOCALE = "en";

// Go over all of the available locales and register them
forEach(locales, (value, key) => {
    addLocaleData({
        locale: key,
        pluralRuleFunction: (input: any) => input,
    });
});

interface StateProps {
    locale: any;
}

interface OwnProps {
    children: React.ReactNode;
}

type ComponentProps = OwnProps & StateProps;

const Localization = ({locale, children}: ComponentProps) => {

    const [messages, setMessages] = useState(null);

    useEffect(() => {
        import(`../constants/locales/${locale}.json`)
            .then(module => {
                setMessages(locale === DEFAULT_LOCALE // english is our default, complete locale
                    ? locales[DEFAULT_LOCALE]
                    : {...locales[DEFAULT_LOCALE], ...module.default});
            }).catch(() => {
            setMessages(locales[DEFAULT_LOCALE])
        });
    }, [locale]);

    return (
        // return default div when messages still loading
        messages ?
        <IntlProvider locale={locale} key={locale} messages={messages}>
            {children}
        </IntlProvider> : <div></div>
    );


};

export default Localization;
